module.exports = __webpack_public_path__ + "static/media/ben-mullins-5QTQz-oYk1A_large.4f0a04a8.jpg";